import type { FC } from "react";
import { useNavigate, useParams } from "react-router";

// Taken from the `prop-types` library as it was the only thing we needed
// https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/prop-types/index.d.ts#L5
type ReactComponentLike = string |
    ((props: any) => any) |
    (new(props: any, context: any) => any);

/**
 * Inject the route parameters into the provided route.
 * This should not be used for any new development, instead hooks should be used.
 * @param Route
 * @param navigate
 * @constructor
 * @deprecated
 */
export const InjectRouteParams: FC<{
    route: ReactComponentLike;
    navigate?: boolean;
}> = ({
    route: Route,
    navigate,
}) => {
    const allParams = useParams();
    const navigation = useNavigate();

    const props: Record<string, unknown> = {
        ...allParams,
    };

    if(navigate) {
        props.navigate = navigation;
    }

    return (
        <Route
            {...props}
        />
    );
};
